// A market's boost is described by the backend `boost_params` field — a hand-authored
// ";"-separated string passed through verbatim from the JSON config:
//
//   "full label;short label;description"
//
//   full         chip text on wide surfaces (market stats panel)
//   short        chip text where space is tight (market menu row); falls back to "Boost"
//   description  tooltip prose; falls back to the full label on compact surfaces
//
// e.g. "5k mPoints boost;5k boost;Trade PUMP this week to earn a share of 5,000 mPoints".
// Only the full label is required. The description takes the rest of the string, so prose
// may itself contain ";". Absent/empty `boost_params` means the market carries no boost —
// presence of a parsed boost IS the indicator.
export type MarketBoost = {
  full: string;
  short?: string;
  description?: string;
};

export function parseMarketBoost(boostParams?: string): MarketBoost | undefined {
  const [rawFull, rawShort, ...rest] = boostParams?.split(';') ?? [];
  const full = rawFull?.trim();
  if (!full) return undefined;

  return { full, short: rawShort?.trim() || undefined, description: rest.join(';').trim() || undefined };
}
